import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconDpaAfx: TIconComponent = props => (
    <Icon viewBox="0 0 113 29" {...props}>
        <g clipPath="url(#clip0_428_1413)">
            <mask id="mask0_428_1413" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="113" height="29">
                <path d="M112.3 0H0V28.1H112.3V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_428_1413)">
                <path
                    d="M8.40002 22.1001V21.1001H8.30002C7.60003 22.0001 6.40002 22.6001 5.20002 22.5001C1.80002 22.5001 -0.0999756 19.4001 -0.0999756 16.3001C-0.0999756 13.2001 1.80002 10.3001 5.10002 10.3001C6.30002 10.3001 7.40002 10.8001 8.20002 11.7001H8.30002V4.1001H11.6V22.0001H8.40002M6.00002 19.5001C7.70002 19.5001 8.70002 17.8001 8.70002 16.3001C8.70002 14.8001 7.70002 13.1001 6.00002 13.1001C4.30002 13.1001 3.30002 14.8001 3.30002 16.3001C3.30002 17.8001 4.30002 19.5001 6.00002 19.5001Z"
                    fill="#004678"
                />
            </g>
            <path
                d="M17.5 10.6V11.6C18.3 10.7 19.5 10.2 20.7 10.2C23.9 10.2 25.9 13.2 25.9 16.2C25.9 19.2 24 22.4 20.6 22.4C19.4 22.4 18.3 21.9 17.5 21V28.2H14.2V10.6H17.5ZM19.9 19.5C21.6 19.5 22.6 17.8 22.6 16.3C22.6 14.8 21.6 13.1 19.9 13.1C18.2 13.1 17.2 14.8 17.2 16.3C17.2 17.8 18.2 19.5 19.9 19.5Z"
                fill="#004678"
            />
            <path
                d="M38.9 10.6V22H35.7V21C34.9 21.9 33.8 22.4 32.6 22.4C29.2 22.4 27.3 19.4 27.3 16.3C27.3 13.2 29.2 10.3 32.5 10.3C33.7 10.3 34.9 10.8 35.7 11.7V10.6H38.9ZM33.3 19.5C35 19.5 36 17.8 36 16.3C36 14.8 35 13.1 33.3 13.1C31.6 13.1 30.6 14.8 30.6 16.3C30.6 17.8 31.6 19.5 33.3 19.5Z"
                fill="#004678"
            />
            <path
                d="M55.5 0C48.3 0 42.4 5.8 42.4 13C42.4 20.2 48.2 26.1 55.4 26.1C62.6 26.1 68.5 20.3 68.5 13.1C68.5 5.9 62.7 0.1 55.5 0Z"
                fill="#B40A32"
            />
            <path d="M60.5 18.1001H50.5V21.4001H60.5V18.1001Z" fill="white" />
            <path d="M60.5 11.3999H50.5V14.6999H60.5V11.3999Z" fill="white" />
            <path d="M60.5 4.69995H50.5V7.99995H60.5V4.69995Z" fill="white" />
            <path
                d="M75.5 17.9L74.4 22H70.6L75.5 6H80.3L85.3 22.1H81.4L80.1 18L75.5 17.9ZM79.6 15.2L78.6 11.8C78.3 10.9 78 9.6 77.8 8.7C77.6 9.7 77.3 10.9 77.1 11.8L76.1 15.2H79.6Z"
                fill="#004678"
            />
            <path d="M87.2 6H97.1V8.9H90.9V12.6H96.7V15.6H90.9V22.1H87.2V6Z" fill="#004678" />
            <path
                d="M108.1 22.1L106.7 19.2C106.1 18.1 105.7 17.2 105.3 16.3C105 17.2 104.6 18.1 104.1 19.2L102.8 22.1H98.6L103.3 14L98.6 6H102.8L104.2 8.9C104.7 9.9 105 10.7 105.4 11.6C105.8 10.6 106.1 9.9 106.5 8.9L107.9 6H112L107.5 13.9L112.3 22.1H108.1Z"
                fill="#004678"
            />
        </g>
        <defs>
            <clipPath id="clip0_428_1413">
                <rect width="113" height="29" fill="white" />
            </clipPath>
        </defs>
    </Icon>
);
